<section class="main-container">

    <aside class="side-right">

    </aside>

    <!-- Main Content -->
    <div class="center-container">
        
    </div>
</section>